// Google AdSense Configuration
// Replace these values with your actual AdSense publisher ID and ad slot IDs

// Proper environment detection for production
const isProduction = typeof window !== 'undefined' && 
  (window.location.hostname === 'www.snap-tools.online' || 
   window.location.hostname === 'snap-tools.online')

const isDevelopment = typeof window !== 'undefined' && 
  (window.location.hostname === 'localhost' || window.location.hostname.includes('127.0.0.1'))

export const GOOGLE_ADSENSE_CONFIG = {
  publisherId: 'ca-pub-2114945987755692', // Your actual AdSense ID
  enabled: isProduction, // Enable in production only
  testMode: isDevelopment, // Test mode for development only
  
  // Ad Slots for different pages and positions
  adSlots: {
    // Image Compressor Page
    imageCompressor: {
      header: '1234567890',
      content: '0987654321', 
      footer: '1122334455'
    },
    
    // Image Resizer Page
    imageResizer: {
      header: '2345678901',
      content: '1098765432',
      footer: '2233445566'
    },
    
    // Image Converter Page
    imageConverter: {
      header: '3456789012',
      content: '2109876543',
      footer: '3344556677'
    },
    
    // PDF Merger Page
    pdfMerger: {
      header: '4567890123',
      content: '3210987654',
      footer: '4455667788'
    },
    
    // PDF Splitter Page
    pdfSplitter: {
      header: '5678901234',
      content: '4321098765',
      footer: '5566778899'
    },
    
    // PDF Compressor Page
    pdfCompressor: {
      header: '6789012345',
      content: '5432109876',
      footer: '6677889900'
    },
    
    // JPG to PDF Page
    jpgToPdf: {
      header: '7890123456',
      content: '6543210987',
      footer: '7788990011'
    },
    
    // Word to PDF Page
    wordToPdf: {
      header: '8901234567',
      content: '7654321098',
      footer: '8899001122'
    },
    
    // PowerPoint to PDF Page
    powerpointToPdf: {
      header: '9012345678',
      content: '8765432109',
      footer: '9900112233'
    },
    
    // Excel to PDF Page
    excelToPdf: {
      header: '0123456789',
      content: '9876543210',
      footer: '0011223344'
    },
    
    // HTML to PDF Page
    htmlToPdf: {
      header: '1234567890',
      content: '0987654321',
      footer: '1122334455'
    },
    
    // PDF to JPG Page
    pdfToJpg: {
      header: '2345678901',
      content: '1098765432',
      footer: '2233445566'
    },
    
    // PDF to Word Page
    pdfToWord: {
      header: '3456789012',
      content: '2109876543',
      footer: '3344556677'
    },
    
    // PDF to PowerPoint Page
    pdfToPowerpoint: {
      header: '4567890123',
      content: '3210987654',
      footer: '4455667788'
    },
    
    // PDF to Excel Page
    pdfToExcel: {
      header: '5678901234',
      content: '4321098765',
      footer: '5566778899'
    },
    
    // PDF to PDF/A Page
    pdfToPdfA: {
      header: '6789012345',
      content: '5432109876',
      footer: '6677889900'
    },
    
    // Home Page
    home: {
      hero: '7890123456',
      features: '6543210987',
      footer: '7788990011'
    }
  }
}

// Ad position configurations
export const AD_POSITIONS = {
  header: {
    className: 'w-full max-w-4xl mx-auto mb-8',
    style: { minHeight: '90px', width: '100%' },
    format: 'horizontal'
  },
  content: {
    className: 'w-full max-w-2xl mx-auto my-8',
    style: { minHeight: '250px', width: '100%' },
    format: 'rectangle'
  },
  sidebar: {
    className: 'w-full max-w-xs',
    style: { minHeight: '250px', width: '300px' },
    format: 'vertical'
  },
  footer: {
    className: 'w-full max-w-4xl mx-auto mt-8',
    style: { minHeight: '90px', width: '100%' },
    format: 'horizontal'
  }
}

// Ad sizes for different screen sizes
export const RESPONSIVE_AD_SIZES = {
  mobile: {
    width: 320,
    height: 50
  },
  tablet: {
    width: 728,
    height: 90
  },
  desktop: {
    width: 970,
    height: 250
  }
}

// Helper functions for proper AdSense integration
export const shouldDisplayAds = (): boolean => {
  return GOOGLE_ADSENSE_CONFIG.enabled && !GOOGLE_ADSENSE_CONFIG.testMode
}

export const getAdSlotSafely = (adSlot: string): string | null => {
  // Check if the ad slot is valid (not a placeholder)
  if (!isValidAdSlot(adSlot)) {
    return null; // Don't load placeholder/invalid slots
  }
  
  // In production with ads enabled, return valid ad slots only
  if (shouldDisplayAds()) {
    return adSlot;
  }
  
  // In development, return null to show placeholders
  return null;
}

export const isValidAdSlot = (adSlot: string): boolean => {
  // List of known placeholder/test ad slot IDs that should NOT be loaded
  const placeholderSlots = [
    '1234567890', '0987654321', '1122334455',
    '2345678901', '1098765432', '2233445566', 
    '3456789012', '2109876543', '3344556677',
    '4567890123', '3210987654', '4455667788',
    '5678901234', '4321098765', '5566778899',
    '6789012345', '5432109876', '6677889900'
  ];
  
  // If it's a placeholder slot, it's invalid
  if (placeholderSlots.includes(adSlot)) {
    return false;
  }
  
  // In production with ads enabled, only allow non-placeholder slots
  if (shouldDisplayAds()) {
    return !placeholderSlots.includes(adSlot);
  }
  
  // In development, validate format (10+ digits) but allow placeholders for testing
  return /^\d{10,}$/.test(adSlot);
}
